export type Lang = 'en' | 'bm' | 'cn';

export type AppTranslations = {
  home: {
    line1: string;
    line2: string;
    line3: string;
    line4: string;
    line5: string;
    line6: string;
  };
  ageSmoker: {
    title: string;
    smokerQuestion: string;
    yes: string;
    no: string;
    submit: string;
    allRequiredWarning: string;
  };
  pdpa: {
    title: string;
    consentText: string;
    agree: string;
    decline: string;
    consentWarning: string;
    noticeTitle: string;
  };
  phone: {
    instruction: string;
    mobileLabel: string;
    requestOtpButton: string;
    mobileWarning: string;
    otpError: string;
    maxSubmissionsWarning: string;
    turnstileFailed: string;
    confirmTitle: string;
    confirmMobileLabel: string;
    confirmPrompt: string;
    verifyingSecurity: string;
    back: string;
    confirm: string;
  };
  otp: {
    sentMessage: string;
    otpCodeLabel: string;
    submit: string;
    emptyWarning: string;
    verifyError: string;
    profileNotFoundWarning: string;
    waitBeforeSubmit: string;
    readyToSubmit: string;
  };
  thankYou: {
    line1: string;
    line2: string;
  };
  custCompleted: {
    line1: string;
    line2: string;
    line3: string;
  };
  surveyContinue: {
    message: string;
    setBMessage: string;
  };
  setAProfile: {
    title: string;
    nameLabel: string;
    raceLabel: string;
    stateLabel: string;
    areaLabel: string;
    selectRace: string;
    selectState: string;
    continue: string;
    nameWarning: string;
    raceWarning: string;
    stateWarning: string;
    areaWarning: string;
    areaLengthWarning: string;
    incompleteWarning: string;
  };
  prevBrand: {
    question: string;
    loading: string;
    loadError: string;
    requiredWarning: string;
    otherSpecify: string;
    otherSpecifyWarning: string;
    continue: string;
  };
  prevBrandAnswer: {
    whyQuestion: string;
    taste: string;
    brandImage: string;
    productQuality: string;
    price: string;
    productFeatures: string;
    recommendedByOthers: string;
    brandCredibility: string;
    peersSmoking: string;
    otherReasons: string;
    elaborateHint: string;
    elaborateAnswer: string;
    elaborateAnswerWarning: string;
    otherProductQuestion: string;
    selectYesNo: string;
    yes: string;
    no: string;
    continue: string;
    reasonRequiredWarning: string;
    tasteElaborationWarning: string;
    priceElaborationWarning: string;
    productFeaturesElaborationWarning: string;
    brandCredibilityElaborationWarning: string;
    peersSmokingElaborationWarning: string;
    otherProductWarning: string;
  };
  otherProductType: {
    question: string;
    selectProduct: string;
    rmc: string;
    vape: string;
    rrp: string;
    continue: string;
    requiredWarning: string;
  };
  prevBrandAnswerOther: {
    smokeFrequencyQuestion: string;
    smokeFrequencyWarning: string;
    firstProduct: string;
    secondProduct: string;
    times: string;
    offerMoreFlavours: string;
    moreConsiderate: string;
    potentialToReduceRisks: string;
    selectAll: string;
  };
  ldProductNow: {
    variantQuestion: string;
    selectVariant: string;
    loading: string;
    loadError: string;
    motivationQuestion: string;
    selectAll: string;
    taste: string;
    brandImage: string;
    productQuality: string;
    price: string;
    productFeatures: string;
    recommendedByOthers: string;
    mentholFlavorExperience: string;
    elaborateAnswer: string;
    otherProductQuestion: string;
    selectYesNo: string;
    yes: string;
    no: string;
    continue: string;
    variantWarning: string;
    motivationWarning: string;
    elaborateWarning: string;
    otherProductWarning: string;
  };
  whyLdNow: {
    question: string;
    selectAll: string;
    elaborateAnswer: string;
    submit: string;
    reasonRequiredWarning: string;
    elaborateWarning: string;
    sessionExpiredWarning: string;
    incompleteWarning: string;
    submitError: string;
  };
  setBLdBrandOpinion: {
    brandOpinionQuestion: string;
    brandOpinionPlaceholder: string;
    futureLikelihoodQuestion: string;
    selectLikelihood: string;
    whyQuestion: string;
    submit: string;
    allRequiredWarning: string;
    brandOpinionWarning: string;
    likelihoodWarning: string;
    likelihoodWhyWarning: string;
    sessionExpiredWarning: string;
    incompleteWarning: string;
    submitError: string;
  };
  tng: {
    title: string;
    subtitle: string;
    smsNote: string;
    fallbackNote: string;
  };
};

const en: AppTranslations = {
  home: {
    line1: 'Respondents who complete the',
    line2: 'survey will be provided a token',
    line3: "of appreciation.* T&C apply.",
    line4: 'Choose your language to',
    line5: 'proceed if you agree to',
    line6: 'participate in the survey.',
  },
  ageSmoker: {
    title: 'Age',
    smokerQuestion: 'Are you a smoker?',
    yes: 'Yes',
    no: 'No',
    submit: 'Submit',
    allRequiredWarning: 'Please answer all questions before continuing to the next page.',
  },
  pdpa: {
    title: 'PDPA',
    consentText: 'I hereby confirm my consent to the processing of my personal data as set out above.',
    agree: 'Agree',
    decline: 'Decline',
    consentWarning: 'Please tick the terms and condition to continue.',
    noticeTitle: 'NOTICE UNDER THE PERSONAL DATA PROTECTION ACT 2010 ("PDPA")',
  },
  phone: {
    instruction: 'Please input your mobile number for us to send you an OTP.',
    mobileLabel: 'Mobile No.:',
    requestOtpButton: 'Request OTP',
    mobileWarning: 'Please enter your mobile number.',
    otpError: 'Unable to send OTP. Please try again.',
    maxSubmissionsWarning: 'Maximum survey submissions reached for this phone number.',
    turnstileFailed:
      'Security check could not complete. Please check your internet connection and try again.',
    confirmTitle: 'You have entered:',
    confirmMobileLabel: 'Mobile No: ',
    confirmPrompt: 'Please confirm the information is correct.',
    verifyingSecurity: 'Security verification in progress. Please wait...',
    back: 'Back',
    confirm: 'Confirm',
  },
  otp: {
    sentMessage: 'OTP has been sent to your mobile no.:',
    otpCodeLabel: 'OTP Code:',
    submit: 'Submit',
    emptyWarning: 'Please enter the OTP code.',
    verifyError: 'Unable to verify OTP. Please try again.',
    profileNotFoundWarning:
      'We could not load your profile from your previous survey. Please contact support.',
    waitBeforeSubmit:
      'Wait {{seconds}}s before tapping Submit. You can type the code while you wait.',
    readyToSubmit: 'You can tap Submit now.',
  },
  thankYou: {
    line1: 'THANK YOU',
    line2: 'FOR YOUR PARTICIPATION',
  },
  custCompleted: {
    line1: 'Thank you for your interest!',
    line2: "You've already completed",
    line3: 'this survey.',
  },
  surveyContinue: {
    message: 'Survey questions coming soon.',
    setBMessage: 'Set B — next step coming soon.',
  },
  setAProfile: {
    title: 'Your details',
    nameLabel: 'Name',
    raceLabel: 'Race',
    stateLabel: 'State of Residences',
    areaLabel: 'Please specify your area of residence',
    selectRace: 'Select race',
    selectState: 'Select state',
    continue: 'Continue',
    nameWarning: 'Please enter your name.',
    raceWarning: 'Please select your race.',
    stateWarning: 'Please select your state of residence.',
    areaWarning: 'Please specify your area of residence.',
    areaLengthWarning: 'Area of residence must not exceed 160 characters.',
    incompleteWarning: 'Please complete all fields before continuing.',
  },
  prevBrand: {
    question: 'What is your previous smoking brand?',
    loading: 'Loading brands...',
    loadError: 'Unable to load brands. Please try again.',
    requiredWarning: 'Please choose a brand variant before continuing.',
    otherSpecify: 'Others. Please specify:',
    otherSpecifyWarning: 'Please specify your brand.',
    continue: 'Continue',
  },
  prevBrandAnswer: {
    whyQuestion: 'Why did you smoke your previous brand?',
    taste: 'Taste',
    brandImage: 'Brand image',
    productQuality: 'Product quality',
    price: 'Price',
    productFeatures: 'Product features',
    recommendedByOthers: 'Recommended by other people',
    brandCredibility: 'Brand credibility',
    peersSmoking: 'My peers smoke the same brand',
    otherReasons: 'Other reasons, please specify:',
    elaborateHint: 'Please elaborate more',
    elaborateAnswer: 'Please elaborate your answer',
    elaborateAnswerWarning: 'Please elaborate your answer.',
    otherProductQuestion: 'Did you smoke any product other than your previous main product?',
    selectYesNo: 'Yes/No',
    yes: 'Yes',
    no: 'No',
    continue: 'Continue',
    reasonRequiredWarning: 'Please select at least one reason.',
    tasteElaborationWarning: 'Please elaborate on Taste.',
    priceElaborationWarning: 'Please elaborate on Price.',
    productFeaturesElaborationWarning: 'Please elaborate on Product features.',
    brandCredibilityElaborationWarning: 'Please elaborate on Brand credibility.',
    peersSmokingElaborationWarning: 'Please elaborate on My peers smoke the same brand.',
    otherProductWarning: 'Please answer whether you smoked any other product.',
  },
  otherProductType: {
    question: 'What other product did you smoke?',
    selectProduct: 'Select product',
    rmc: 'Other cigarette products',
    vape: 'Vape',
    rrp: 'Heated tobacco product',
    continue: 'Continue',
    requiredWarning: 'Please select a product.',
  },
  prevBrandAnswerOther: {
    smokeFrequencyQuestion:
      'Out of 10 times you smoke, how many times is first product & how many times is second product?',
    smokeFrequencyWarning: 'Please move the slider to answer this question.',
    firstProduct: 'First Product',
    secondProduct: 'Second Product',
    times: 'times',
    offerMoreFlavours: 'Offer more flavours',
    moreConsiderate: 'More considerate to people around me',
    potentialToReduceRisks: 'Has the potential to reduce risks',
    selectAll: 'Please select all that apply to you.',
  },
  ldProductNow: {
    variantQuestion: 'Which LD product do you currently smoke?',
    selectVariant: 'Choose variant',
    loading: 'Loading variants...',
    loadError: 'Unable to load LD variants. Please try again.',
    motivationQuestion: 'What motivates you to buy LD again?',
    selectAll: 'Please select all that apply to you.',
    taste: 'Taste',
    brandImage: 'Brand image',
    productQuality: 'Product quality',
    price: 'Price',
    productFeatures: 'Product features',
    recommendedByOthers: 'Recommended by other people',
    mentholFlavorExperience: 'Menthol & flavour experience',
    elaborateAnswer: 'Please elaborate your answer',
    otherProductQuestion: 'Do you smoke other product than LD?',
    selectYesNo: 'Yes/No',
    yes: 'Yes',
    no: 'No',
    continue: 'Continue',
    variantWarning: 'Please select your LD variant.',
    motivationWarning: 'Please select at least one motivation.',
    elaborateWarning: 'Please elaborate your answer.',
    otherProductWarning: 'Please answer whether you smoke other products than LD.',
  },
  whyLdNow: {
    question: 'What motivates you to try LD now?',
    selectAll: 'Please select all that apply to you.',
    elaborateAnswer: 'Please elaborate your answer',
    submit: 'Submit',
    reasonRequiredWarning: 'Please select at least one reason.',
    elaborateWarning: 'Please elaborate your answer.',
    sessionExpiredWarning: 'Session expired. Please start again from the phone step.',
    incompleteWarning: 'Survey data is incomplete. Please go back and complete the previous steps.',
    submitError: 'Unable to save. Please try again.',
  },
  setBLdBrandOpinion: {
    brandOpinionQuestion: 'What do you think of brand LD?',
    brandOpinionPlaceholder: 'Type your answer here',
    futureLikelihoodQuestion:
      'On a scale of 1 to 5, how likely are you to consume LD as your main product in the future? (1= not at all, 5= most likely)',
    selectLikelihood: '1-5',
    whyQuestion: 'Why?',
    submit: 'Submit',
    allRequiredWarning: 'Please answer all questions before continuing to the next page.',
    brandOpinionWarning: 'Please share your thoughts on brand LD.',
    likelihoodWarning: 'Please select a score from 1 to 5.',
    likelihoodWhyWarning: 'Please tell us why you chose that score.',
    sessionExpiredWarning: 'Session expired. Please start again from the phone step.',
    incompleteWarning: 'Survey data is incomplete. Please go back and complete the previous steps.',
    submitError: 'Unable to save. Please try again.',
  },
  tng: {
    title: 'THANK YOU',
    subtitle: 'FOR YOUR PARTICIPATION',
    smsNote: 'You will receive the e-Wallet redemption PIN via SMS',
    fallbackNote:
      'Your voucher could not be loaded in this view. If you just completed the survey, open this page from the survey step again in the same browser tab.',
  },
};

const bm: AppTranslations = {
  home: {
    line1: 'Responden yang melengkapkan',
    line2: 'kaji selidik akan diberikan token',
    line3: 'penghargaan.* T&S terpakai.',
    line4: 'Pilih bahasa anda untuk',
    line5: 'meneruskan jika anda bersetuju',
    line6: 'untuk menyertai kaji selidik.',
  },
  ageSmoker: {
    title: 'Umur',
    smokerQuestion: 'Adakah anda perokok?',
    yes: 'Ya',
    no: 'Tidak',
    submit: 'Hantar',
    allRequiredWarning: 'Sila jawab semua soalan sebelum meneruskan ke halaman seterusnya.',
  },
  pdpa: {
    title: 'PDPA',
    consentText:
      'Dengan ini saya bersetuju dan mengesahkan persetujuan saya untuk memprocess data peribadi saya seperti dinyatakan di atas.',
    agree: 'Setuju',
    decline: 'Tidak Setuju',
    consentWarning: 'Sila tandakan kotak pilihan untuk mengesahkan persetujuan anda',
    noticeTitle: 'NOTIS DI BAWAH AKTA PERLINDUNGAN DATA PERIBADI 2010 (“PDPA")',
  },
  phone: {
    instruction: 'Sila masukkan nombor telefon bimbit anda untuk kami menghantar OTP.',
    mobileLabel: 'No. Telefon:',
    requestOtpButton: 'Minta OTP',
    mobileWarning: 'Sila masukkan nombor telefon bimbit anda.',
    otpError: 'Tidak dapat menghantar OTP. Sila cuba lagi.',
    maxSubmissionsWarning: 'Had maksimum penyertaan kaji selidik untuk nombor telefon ini telah dicapai.',
    turnstileFailed:
      'Pemeriksaan keselamatan tidak dapat diselesaikan. Sila semak sambungan internet anda dan cuba lagi.',
    confirmTitle: 'Anda telah memasukkan:',
    confirmMobileLabel: 'No. Telefon: ',
    confirmPrompt: 'Sila sahkan maklumat adalah betul.',
    verifyingSecurity: 'Pengesahan keselamatan sedang diproses. Sila tunggu...',
    back: 'Kembali',
    confirm: 'Sahkan',
  },
  otp: {
    sentMessage: 'OTP telah dihantar ke no. telefon bimbit anda:',
    otpCodeLabel: 'Kod OTP:',
    submit: 'Hantar',
    emptyWarning: 'Sila masukkan kod OTP.',
    verifyError: 'Tidak dapat mengesahkan OTP. Sila cuba lagi.',
    profileNotFoundWarning:
      'Profil anda daripada kaji selidik sebelumnya tidak dapat dimuatkan. Sila hubungi sokongan.',
    waitBeforeSubmit:
      'Tunggu {{seconds}}s sebelum mengetik Hantar. Anda boleh taip kod semasa menunggu.',
    readyToSubmit: 'Anda boleh mengetik Hantar sekarang.',
  },
  thankYou: {
    line1: 'TERIMA KASIH',
    line2: 'ATAS PENYERTAAN ANDA',
  },
  custCompleted: {
    line1: 'Terima kasih atas minat anda!',
    line2: 'Anda telah melengkapkan',
    line3: 'kaji selidik ini.',
  },
  surveyContinue: {
    message: 'Soalan kaji selidik akan datang tidak lama lagi.',
    setBMessage: 'Set B — langkah seterusnya akan datang tidak lama lagi.',
  },
  setAProfile: {
    title: 'Butiran anda',
    nameLabel: 'Nama',
    raceLabel: 'Bangsa',
    stateLabel: 'Negeri Kediaman',
    areaLabel: 'Sila nyatakan kawasan kediaman anda',
    selectRace: 'Pilih bangsa',
    selectState: 'Pilih negeri',
    continue: 'Teruskan',
    nameWarning: 'Sila masukkan nama anda.',
    raceWarning: 'Sila pilih bangsa anda.',
    stateWarning: 'Sila pilih negeri kediaman anda.',
    areaWarning: 'Sila nyatakan kawasan kediaman anda.',
    areaLengthWarning: 'Kawasan kediaman tidak boleh melebihi 160 aksara.',
    incompleteWarning: 'Sila lengkapkan semua medan sebelum meneruskan.',
  },
  prevBrand: {
    question: 'Apakah jenama rokok anda sebelum ini?',
    loading: 'Memuatkan jenama...',
    loadError: 'Tidak dapat memuatkan senarai jenama. Sila cuba lagi.',
    requiredWarning: 'Sila pilih varian jenama sebelum meneruskan.',
    otherSpecify: 'Lain-lain. Sila nyatakan:',
    otherSpecifyWarning: 'Sila nyatakan jenama anda.',
    continue: 'Teruskan',
  },
  prevBrandAnswer: {
    whyQuestion: 'Mengapa anda merokok jenama anda sebelum ini?',
    taste: 'Rasa',
    brandImage: 'Imej jenama',
    productQuality: 'Kualiti produk',
    price: 'Harga',
    productFeatures: 'Ciri produk',
    recommendedByOthers: 'Disyorkan oleh orang lain',
    brandCredibility: 'Kredibiliti jenama',
    peersSmoking: 'Rakan sebaya saya merokok jenama yang sama',
    otherReasons: 'Sebab lain, sila nyatakan:',
    elaborateHint: 'Sila jelaskan dengan lebih lanjut',
    elaborateAnswer: 'Sila jelaskan jawapan anda',
    elaborateAnswerWarning: 'Sila jelaskan jawapan anda.',
    otherProductQuestion: 'Adakah anda merokok produk lain selain produk utama anda sebelum ini?',
    selectYesNo: 'Ya/Tidak',
    yes: 'Ya',
    no: 'Tidak',
    continue: 'Teruskan',
    reasonRequiredWarning: 'Sila pilih sekurang-kurangnya satu sebab.',
    tasteElaborationWarning: 'Sila jelaskan tentang Rasa.',
    priceElaborationWarning: 'Sila jelaskan tentang Harga.',
    productFeaturesElaborationWarning: 'Sila jelaskan tentang Ciri produk.',
    brandCredibilityElaborationWarning: 'Sila jelaskan tentang Kredibiliti jenama.',
    peersSmokingElaborationWarning:
      'Sila jelaskan tentang Rakan sebaya saya merokok jenama yang sama.',
    otherProductWarning: 'Sila jawab sama ada anda merokok produk lain.',
  },
  otherProductType: {
    question: 'Apakah produk lain yang anda merokok?',
    selectProduct: 'Pilih produk',
    rmc: 'Produk rokok lain',
    vape: 'Vape',
    rrp: 'Produk tembakau dipanaskan',
    continue: 'Teruskan',
    requiredWarning: 'Sila pilih produk.',
  },
  prevBrandAnswerOther: {
    smokeFrequencyQuestion:
      'Daripada 10 kali anda merokok, berapa kali produk pertama & berapa kali produk kedua?',
    smokeFrequencyWarning: 'Sila gerakkan peluncur untuk menjawab soalan ini.',
    firstProduct: 'Produk Pertama',
    secondProduct: 'Produk Kedua',
    times: 'kali',
    offerMoreFlavours: 'Menawarkan lebih banyak perisa',
    moreConsiderate: 'Lebih prihatin kepada orang di sekeliling saya',
    potentialToReduceRisks: 'Berpotensi mengurangkan risiko',
    selectAll: 'Sila pilih semua yang berkenaan dengan anda.',
  },
  ldProductNow: {
    variantQuestion: 'Produk LD manakah yang anda sedang merokok?',
    selectVariant: 'Pilih varian LD',
    loading: 'Memuatkan varian...',
    loadError: 'Tidak dapat memuatkan varian LD. Sila cuba lagi.',
    motivationQuestion: 'Apakah yang mendorong anda membeli LD lagi?',
    selectAll: 'Sila pilih semua yang berkenaan dengan anda.',
    taste: 'Rasa',
    brandImage: 'Imej jenama',
    productQuality: 'Kualiti produk',
    price: 'Harga',
    productFeatures: 'Ciri produk',
    recommendedByOthers: 'Disyorkan oleh orang lain',
    mentholFlavorExperience: 'Pengalaman mentol & perisa',
    elaborateAnswer: 'Sila jelaskan jawapan anda',
    otherProductQuestion: 'Adakah anda merokok produk lain selain LD?',
    selectYesNo: 'Ya/Tidak',
    yes: 'Ya',
    no: 'Tidak',
    continue: 'Teruskan',
    variantWarning: 'Sila pilih varian LD anda.',
    motivationWarning: 'Sila pilih sekurang-kurangnya satu motivasi.',
    elaborateWarning: 'Sila jelaskan jawapan anda.',
    otherProductWarning: 'Sila jawab sama ada anda merokok produk lain selain LD.',
  },
  whyLdNow: {
    question: 'Apakah yang mendorong anda untuk mencuba LD sekarang?',
    selectAll: 'Sila pilih semua yang berkenaan dengan anda.',
    elaborateAnswer: 'Sila jelaskan jawapan anda',
    submit: 'Hantar',
    reasonRequiredWarning: 'Sila pilih sekurang-kurangnya satu sebab.',
    elaborateWarning: 'Sila jelaskan jawapan anda.',
    sessionExpiredWarning: 'Sesi tamat. Sila mulakan semula dari langkah telefon.',
    incompleteWarning: 'Data kaji selidik tidak lengkap. Sila kembali dan lengkapkan langkah sebelumnya.',
    submitError: 'Tidak dapat menyimpan. Sila cuba lagi.',
  },
  setBLdBrandOpinion: {
    brandOpinionQuestion: 'Apakah pendapat anda tentang jenama LD?',
    brandOpinionPlaceholder: 'Taip jawapan anda di sini',
    futureLikelihoodQuestion:
      'Pada skala 1 hingga 5, sejauh manakah kemungkinan anda menggunakan LD sebagai produk utama pada masa hadapan? (1= langsung tidak, 5= paling berkemungkinan)',
    selectLikelihood: '1-5',
    whyQuestion: 'Mengapa?',
    submit: 'Hantar',
    allRequiredWarning: 'Sila jawab semua soalan sebelum meneruskan ke halaman seterusnya.',
    brandOpinionWarning: 'Sila kongsi pendapat anda tentang jenama LD.',
    likelihoodWarning: 'Sila pilih skor dari 1 hingga 5.',
    likelihoodWhyWarning: 'Sila beritahu kami mengapa anda memilih skor tersebut.',
    sessionExpiredWarning: 'Sesi tamat. Sila mulakan semula dari langkah telefon.',
    incompleteWarning: 'Data kaji selidik tidak lengkap. Sila kembali dan lengkapkan langkah sebelumnya.',
    submitError: 'Tidak dapat menyimpan. Sila cuba lagi.',
  },
  tng: {
    title: 'TERIMA KASIH',
    subtitle: 'ATAS PENYERTAAN ANDA',
    smsNote: 'Anda akan menerima PIN penebusan e-Wallet melalui SMS',
    fallbackNote:
      'Baucar anda tidak dapat dimuatkan dalam paparan ini. Jika anda baru sahaja melengkapkan kaji selidik, buka halaman ini semula dari langkah kaji selidik dalam tab pelayar yang sama.',
  },
};

const cn: AppTranslations = {
  home: {
    line1: '完成本问卷的受访者',
    line2: '将收到一份小小心意',
    line3: '以表谢意。*须遵守条款与细则。',
    line4: '若您同意参与本问卷',
    line5: '请选择语言',
    line6: '继续。',
  },
  ageSmoker: {
    title: '年龄',
    smokerQuestion: '您是否为吸烟者？',
    yes: '是',
    no: '否',
    submit: '提交',
    allRequiredWarning: '请先回答所有问题，再继续下一页。',
  },
  pdpa: {
    title: '个人数据保护声明（PDPA）',
    consentText: '本人特此确认同意按上述说明处理本人的个人数据。',
    agree: '同意',
    decline: '不同意',
    consentWarning: '请勾选条款与条件以继续。',
    noticeTitle: '2010年个人数据保护法（“PDPA”）通知',
  },
  phone: {
    instruction: '请输入手机号码，以便我们向您发送一次性验证码（OTP）。',
    mobileLabel: '手机号码：',
    requestOtpButton: '获取验证码',
    mobileWarning: '请输入您的手机号码。',
    otpError: '无法发送验证码，请重试。',
    maxSubmissionsWarning: '此手机号码已达到问卷提交次数上限。',
    turnstileFailed: '安全验证未能完成。请检查网络连接后重试。',
    confirmTitle: '您已输入：',
    confirmMobileLabel: '手机号码：',
    confirmPrompt: '请确认信息正确。',
    verifyingSecurity: '正在进行安全验证，请稍候…',
    back: '返回',
    confirm: '确认',
  },
  otp: {
    sentMessage: '验证码已发送至您的手机号码：',
    otpCodeLabel: '验证码：',
    submit: '提交',
    emptyWarning: '请输入验证码。',
    verifyError: '无法验证验证码，请重试。',
    profileNotFoundWarning: '无法读取您上一次问卷的个人资料，请联系客服。',
    waitBeforeSubmit: '请等待 {{seconds}} 秒后再点击提交。等待期间可输入验证码。',
    readyToSubmit: '现在可以点击提交。',
  },
  thankYou: {
    line1: '感谢您',
    line2: '参与本问卷',
  },
  custCompleted: {
    line1: '感谢您的关注！',
    line2: '您已完成',
    line3: '本问卷。',
  },
  surveyContinue: {
    message: '问卷问题即将推出。',
    setBMessage: 'Set B — 下一步即将推出。',
  },
  setAProfile: {
    title: '您的资料',
    nameLabel: '姓名',
    raceLabel: '种族',
    stateLabel: '居住州属',
    areaLabel: '请填写您的居住地区',
    selectRace: '请选择种族',
    selectState: '请选择州属',
    continue: '继续',
    nameWarning: '请输入姓名。',
    raceWarning: '请选择种族。',
    stateWarning: '请选择居住州属。',
    areaWarning: '请填写居住地区。',
    areaLengthWarning: '居住地区不得超过 160 个字符。',
    incompleteWarning: '请填写所有必填资料后再继续。',
  },
  prevBrand: {
    question: '您之前抽的是哪个品牌？',
    loading: '正在加载品牌…',
    loadError: '无法加载品牌，请重试。',
    requiredWarning: '请先选择品牌系列再继续。',
    otherSpecify: '其他，请注明：',
    otherSpecifyWarning: '请注明您的品牌。',
    continue: '继续',
  },
  prevBrandAnswer: {
    whyQuestion: '您之前选择该品牌的原因是什么？',
    taste: '口味',
    brandImage: '品牌形象',
    productQuality: '产品质量',
    price: '价格',
    productFeatures: '产品特性',
    recommendedByOthers: '他人推荐',
    brandCredibility: '品牌信誉',
    peersSmoking: '身边朋友也抽同一品牌',
    otherReasons: '其他原因，请注明：',
    elaborateHint: '请进一步说明',
    elaborateAnswer: '请详细说明您的答案',
    elaborateAnswerWarning: '请详细说明您的答案。',
    otherProductQuestion: '除了之前主要抽的产品外，您是否还抽过其他产品？',
    selectYesNo: '是/否',
    yes: '是',
    no: '否',
    continue: '继续',
    reasonRequiredWarning: '请至少选择一个原因。',
    tasteElaborationWarning: '请就“口味”作进一步说明。',
    priceElaborationWarning: '请就“价格”作进一步说明。',
    productFeaturesElaborationWarning: '请就“产品特性”作进一步说明。',
    brandCredibilityElaborationWarning: '请就“品牌信誉”作进一步说明。',
    peersSmokingElaborationWarning: '请就“身边朋友也抽同一品牌”作进一步说明。',
    otherProductWarning: '请回答您是否抽过其他产品。',
  },
  otherProductType: {
    question: '您还抽过哪类其他产品？',
    selectProduct: '请选择产品',
    rmc: '其他香烟产品',
    vape: '电子烟（Vape）',
    rrp: '加热式烟草产品',
    continue: '继续',
    requiredWarning: '请选择一项产品。',
  },
  prevBrandAnswerOther: {
    smokeFrequencyQuestion: '假设您吸烟 10 次，第一种产品和第二种产品各占几次？',
    smokeFrequencyWarning: '请拖动滑块选择您的答案。',
    firstProduct: '第一种产品',
    secondProduct: '第二种产品',
    times: '次',
    offerMoreFlavours: '提供更多口味',
    moreConsiderate: '更顾及身边的人',
    potentialToReduceRisks: '具有降低风险的潜力',
    selectAll: '请选择所有适用项。',
  },
  ldProductNow: {
    variantQuestion: '您目前抽的是哪款 LD 产品？',
    selectVariant: '请选择产品系列',
    loading: '正在加载产品系列…',
    loadError: '无法加载 LD 产品系列，请重试。',
    motivationQuestion: '是什么促使您再次购买 LD？',
    selectAll: '请选择所有适用项。',
    taste: '口味',
    brandImage: '品牌形象',
    productQuality: '产品质量',
    price: '价格',
    productFeatures: '产品特性',
    recommendedByOthers: '他人推荐',
    mentholFlavorExperience: '薄荷与口味体验',
    elaborateAnswer: '请详细说明您的答案',
    otherProductQuestion: '除了 LD，您是否还抽其他产品？',
    selectYesNo: '是/否',
    yes: '是',
    no: '否',
    continue: '继续',
    variantWarning: '请选择您的 LD 产品系列。',
    motivationWarning: '请至少选择一个原因。',
    elaborateWarning: '请详细说明您的答案。',
    otherProductWarning: '请选择您是否还抽 LD 以外的其他产品。',
  },
  whyLdNow: {
    question: '是什么促使您现在尝试 LD？',
    selectAll: '请选择所有适用项。',
    elaborateAnswer: '请详细说明您的答案',
    submit: '提交',
    reasonRequiredWarning: '请至少选择一个原因。',
    elaborateWarning: '请详细说明您的答案。',
    sessionExpiredWarning: '操作已超时，请从输入手机号码的步骤重新开始。',
    incompleteWarning: '问卷资料不完整，请返回并完成之前的步骤。',
    submitError: '无法保存，请重试。',
  },
  setBLdBrandOpinion: {
    brandOpinionQuestion: '您对 LD 品牌有什么看法？',
    brandOpinionPlaceholder: '请在此输入您的答案',
    futureLikelihoodQuestion:
      '以 1 至 5 分为标准，您未来将 LD 作为主要产品使用的可能性有多大？（1＝完全不可能，5＝最有可能）',
    selectLikelihood: '1-5',
    whyQuestion: '为什么？',
    submit: '提交',
    allRequiredWarning: '请先回答所有问题，再继续下一页。',
    brandOpinionWarning: '请分享您对 LD 品牌的看法。',
    likelihoodWarning: '请选择 1 至 5 的分数。',
    likelihoodWhyWarning: '请说明您选择该分数的原因。',
    sessionExpiredWarning: '操作已超时，请从输入手机号码的步骤重新开始。',
    incompleteWarning: '问卷资料不完整，请返回并完成之前的步骤。',
    submitError: '无法保存，请重试。',
  },
  tng: {
    title: '感谢您',
    subtitle: '参与本问卷',
    smsNote: '您将通过短信收到电子钱包兑换码。',
    fallbackNote:
      '无法在此页面加载您的兑换券。若您刚完成问卷，请在同一浏览器标签页中从问卷流程重新进入本页。',
  },
};

const translations: Record<Lang, AppTranslations> = { en, bm, cn };

export function getTranslations(lang: Lang): AppTranslations {
  return translations[lang];
}
